import Vue from "vue";
export enum EventType {
  SESSION_EXPIRING = "sessionExpiring",
  LOGOUT = "logout"
}
export default new Vue();